import src from "IMAGE";
export default { src, width: 192, height: 103, blurWidth: 0, blurHeight: 0};
